import { withAuthUser } from 'next-firebase-auth'
import * as Page from 'views/about-more'

export const getStaticProps = Page.getStaticProps

export default withAuthUser<Page.AboutMorePageProps>()(Page.AboutMore)
